import { FaClock, FaMapMarkerAlt, FaCalendarAlt, FaParking } from 'react-icons/fa';
import { GiDress } from "react-icons/gi";
import { BiDrink } from "react-icons/bi";

import barraca from '../assets/images/barraca.jpg';

const EventDetail = () => {
  const events = [
    {
      title: "Pre-boda casa rural",
      date: "Viernes, 11 de Septiembre 2026",
      time: "18:30 - 23:00",
      location: <a href="https://maps.app.goo.gl/EdSy8WC4bizYb9Xo6" className="underline" target="_blank">Casa rural en Villamarchante (AUDIOTIMER), Valencia</a>,
      parking: <>
        <span className="font-semibold"><a href="https://maps.app.goo.gl/bLhXpATjU5jE7iyAA" target="_blank" className="underline">Parking de tierra contiguo a la casa rural</a></span>
        <br />
      </>,
      dressCode: 'Guapitos para cena. Smart casual. Bañador',
      description: 'Cocktail / cena informal, cervezas, piscina y buen ambiente',
      map: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1325.0243699165396!2d-0.6570901302929283!3d39.5438061324015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd60f7d1881cddc5%3A0x3de6e18bb44310d8!2sAUDIOTIMER%20SL!5e1!3m2!1ses!2ses!4v1788601974092!5m2!1ses!2ses"
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
    },
    {
      title: "Boda",
      date: "Sábado, 12 de Septiembre 2026",
      time: "12:00 - 23:30",
      location: <a href="https://maps.app.goo.gl/cNHnwUdNAZamo2rA6" className="underline" target="_blank">Barraca el Palmar, la albufera, Valencia</a>,
      parking: <>
        <p> 
          <a href="https://maps.app.goo.gl/wWhA2KHXj1ipCodn9" target="_blank" className="underline">Hay un parking privado justo a las puertas de la barraca</a>. Tendréis que llevar dinero efectivo por coche.
        </p>
        <p className="mt-1">Recordad que habrá <span className="font-semibold">autobús</span> desde la ciudad de las artes y las ciencias si preferís no coger el coche.</p>
      </>,
      dressCode: 'Boda de verano: Elegante pero relajado',
      description: 'Ceremonia y boda de día',
      map: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.811915234699!2d-0.32175612372654644!3d39.31518672194441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd61b58b3d1a4001%3A0xeff8f1d74ac00167!2sLa%20Barraca%20del%20Palmar%20by%20Grupo%20El%20Alto!5e0!3m2!1ses!2ses!4v1768148332340!5m2!1ses!2ses" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
    },
    {
      title: "Almuerzo en el club nautico de Valencia",
      date: "Domingo, 13 de Septiembre 2026",
      time: "12:00h - 16:00h",
      location: <a href="https://maps.app.goo.gl/T9o8HYK6D9AbTqiA8" target="_blank">Plan beach, Real Club Náutico de Valencia</a>,
      parking: <>
        <span className="font-semibold">Parking del Real Club Náutico / La Marina.</span>
        <br />
        Hay bastante aparcamiento en la misma puerta del restaurante, dentro del recinto de La Marina. Los domingos suele haber sitio de sobra. 
      </>,
      dressCode: 'Informal',
      description: 'Almuerzo con vistas al mar',
      // additionalMapNotes: <p>Pendiente de concretar. ¡Estad atentos!. <br></br> Una cosa es segura, será en Valencia!</p>,
      map: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.8306574394715!2d-0.3262035236223544!3d39.425705415358834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd60492521699b55%3A0x595afb3c47e6aecc!2sPlan%20Beach!5e1!3m2!1ses!2ses!4v1787387824952!5m2!1ses!2ses" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
            </iframe>
    }
  ];

  const mapInitOpts = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627
    },
    zoom: 11
  };

  return (
    <section className="py-16 px-4 bg-rose-50" id="event-details">
      <div className="max-w-4md max-w-6xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-12">Timeline del fin de semana</h2>
        
        <img src={barraca} className="opacity-90 rounded-md md:max-w-[400px] m-auto mt-4 mb-12" />
        
        <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-6">
          {events.map((event, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold text-rose-600 mb-4">{event.title}</h3>
              
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <FaCalendarAlt className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.date}</p>
                </div>
                
                <div className="flex items-start gap-3">
                  <FaClock className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.time}</p>
                </div>

                <div className="flex items-start gap-3">
                  <BiDrink className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.description}</p>
                </div>
                
                <div className="flex items-start gap-3">
                  <GiDress alt="Código de vestimenta" className="text-rose-400 mt-1 flex-shrink-0" styles={{ width: '20px' }} />
                  <p>{event.dressCode}</p>
                </div>
                
                <div className="flex items-start gap-3">
                  <FaMapMarkerAlt className="text-rose-400 mt-1 flex-shrink-0" />
                  <p>{event.location}</p>
                </div>

                { event.parking ? (
                  <div className="flex items-start gap-3">
                    <FaParking className="text-rose-400 mt-1 flex-shrink-0" />
                    <div>{event.parking}</div>
                  </div>
                ) : undefined }
              </div>
              

              <div className="h-64 w-full bg-gray-200 rounded-lg overflow-hidden mt-10">
                { event.map }
              </div>

              { event.additionalMapNotes ? (
                <div className="text-m font-semibold text-rose-400 mt-5 mb-2">
                  { event.additionalMapNotes }
                </div>
              )
               : undefined }
              {/* <button className="mt-6 px-4 py-2 bg-rose-600 text-white rounded-full hover:bg-rose-700 transition-all flex items-center gap-2 mx-auto cursor-pointer">
                <FaMapMarkerAlt /> Ver ubicación
                </button> */}
            </div>
          ))}
        </div>
        
        {/* <div className="mt-12 bg-white p-6 rounded-lg shadow-md">
          <div className="h-64 w-full bg-gray-200 rounded-lg overflow-hidden">
            <iframe 
            title="Lokasi Pernikahan"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.028920711012!2d115.25972231533865!3d-8.733752393758266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd246bc8b3b08a5%3A0x4c1e3b0d5b9d5b1f!2sUbud%2C%20Gianyar%2C%20Bali!5e0!3m2!1sen!2sid!4v1620000000000!5m2!1sen!2sid" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy"
            ></iframe>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default EventDetail;